import Inputmask from "inputmask";

const inputMaskDirective = {
    beforeMount: (el, binding) => {
        if (typeof binding.value === 'string') {
            Inputmask(binding.value).mask(el)
        } else {
            Inputmask(binding.value.name, {...binding.value.options}).mask(el)
        }

    },
};

export default inputMaskDirective